import { React } from "react";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    page: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    },
}));

const MobilePage = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.page} {...props}>
            {props.children}
        </Box>
    );
}

export default MobilePage;